import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ComplianceBanner } from "./ComplianceBanner";

export const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[#0B0B0B]">
    <ComplianceBanner />
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
